import React, { useRef, useEffect, useContext } from "react"
import { CardBody } from "reactstrap"
import PropTypes from "prop-types"
import { Spinner } from "components/spinner"
import { userInfo } from "utils"
import Message from "./Message"
import MessageInput from "./MessageInput"
import MessageContext from "../MessageContext"

const MessageListBody = ({
  chatRoomId,
  chatUser,
  loading,
  messages,
  disabled
}) => {
  const messagesEnd = useRef(null)
  const { isInitChat } = useContext(MessageContext)
  const info = userInfo()

  useScroll(messages, messagesEnd, isInitChat)

  return (
    <CardBody>
      <div className="chat-box" style={{ height: "calc(100vh - 350px)" }}>
        <ul className="chat-list">
          {loading === true && (
            <li>
              <Spinner />
            </li>
          )}
          {loading === false &&
            messages.map((message, index) => (
              <Message
                key={index}
                message={message}
                chatUser={chatUser}
                userInfo={info}
              />
            ))}
          <li
            style={{
              float: "left",
              clear: "both"
            }}
            ref={el => {
              messagesEnd.current = el
            }}
          />
        </ul>
      </div>
      <MessageInput chatRoomId={chatRoomId} disabled={disabled} />
    </CardBody>
  )
}

const useScroll = (messages, messagesEnd, isInitChat) => {
  useEffect(() => {
    if (
      messages.length > 0 &&
      messagesEnd &&
      messagesEnd.current &&
      isInitChat === true
    ) {
      messagesEnd.current.scrollIntoView({ block: "end" })
    } else if (
      messages.length > 0 &&
      messagesEnd &&
      messagesEnd.current &&
      isInitChat === false
    ) {
      setTimeout(() => {
        messagesEnd &&
          messagesEnd.current &&
          messagesEnd.current.scrollIntoView({
            behavior: "smooth",
            block: "end"
          })
      }, 250)
    }
  }, [messages, messagesEnd, isInitChat])
}

MessageListBody.propTypes = {
  chatRoomId: PropTypes.string.isRequired,
  chatUser: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  messages: PropTypes.array.isRequired,
  disabled: PropTypes.bool
}

export default MessageListBody
